$(document).ready(function (){
     var swiper = new Swiper(".swiper-container", {
      slidesPerView: 2,
      grabCursor: true, 
      observer: true,
      spaceBetween: 30,
      observeParents: true,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true,
      },
  breakpoints: {    
    320: {
      slidesPerView: 1
    },   
    480: {
      slidesPerView: 1
    },    
    640: {
      slidesPerView: 2
    },
    1024: {
      slidesPerView: 2
    }
  }
});
});


